exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".expired-modal .warranty-large-modal .modal-dialog .modal-body{overflow:hidden}.expired-modal .warranty-large-modal .modal-dialog .modal-body iframe{border:0;height:100%;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/session-expired-modal/index.scss
// module id = 5281
// module chunks = 0